import { query, mutation } from '@/dex-shared/helpers/graphql';
import { slugifyString } from '@/dex-shared/lib/StringHelper';

export default {
  state: {
    lists: [],
    list: null,
    pdfLink: null,
  },
  getters: {
    currentList: (state: any) => {
      if (state.list) {
        let itemNodes = state.list.listItemsByListId;
        let items;
        if (itemNodes) {
          items = state.list.listItemsByListId.nodes.map((itemNode: any) => {
            let item =
              itemNode.questionByQuestionId ||
              itemNode.articleByArticleId ||
              itemNode.videoByVideoId;

            if (item.content && typeof item.content == 'string') {
              item.content = item.content;
            }

            if (
              item.interactiveData &&
              typeof item.interactiveData == 'string'
            ) {
              item.interactiveData = item.interactiveData;
            }

            if (item.providerId) {
              item.providerId = item.providerId;
              item.providerType = item.providerType;
            }

            if (itemNode.questionByQuestionId) {
              item.type = 'question';
              item.reference = 'questao';
            } else if (itemNode.articleByArticleId) {
              item.type = 'article';
              item.reference = 'explicacao';
            } else if (itemNode.videoByVideoId) {
              item.type = 'video';
              item.reference = 'video';
            }
            return item;
          });
        }
        let materials;
        if (state.list.materialsByListId) {
          materials = state.list.materialsByListId.nodes;
        } else {
          materials = false;
        }
        let boards: any[] = [];
        let boardSections: any[] = [];
        let boardSubsections: any[] = [];
        let path: String = '';
        if (materials) {
          materials.forEach((material: any) => {
            if (material.boardByBoardId) {
              material.boardByBoardId.materialId = material.id;
              let board = material.boardByBoardId;
              if (
                board.boardsClassroomsByBoardId &&
                board.boardsClassroomsByBoardId.nodes.length > 0
              ) {
                board.classroom =
                  board.boardsClassroomsByBoardId.nodes[0].classroomByClassroomId;
                path = `https://dex.descomplica.com.br/${board.classroom.slug}/${board.slug}/${state.list.slug}`;
              }
              boards.push(material.boardByBoardId);
            }
            if (material.boardSectionByBoardSectionsId) {
              material.boardSectionByBoardSectionsId.materialId = material.id;
              boardSections.push(material.boardSectionByBoardSectionsId);
            }
            if (material.boardSubsectionByBoardSubsectionsId) {
              material.boardSubsectionByBoardSubsectionsId.materialId =
                material.id;
              boardSubsections.push(
                material.boardSubsectionByBoardSubsectionsId,
              );
            }
          });
        }
        return {
          id: state.list.id,
          name: state.list.name,
          slug: state.list.slug,
          description: state.list.description,
          type: state.list.type,
          author: state.list.author,
          publishDate: state.list.publishDate,
          items: items,
          boards: boards,
          boardSections: boardSections,
          boardSubsections: boardSubsections,
          path: path,
        };
      }
      return {};
    },
  },
  mutations: {
    SET_LISTS(state: any, lists: any) {
      state.lists = lists.map((list: any) => {
        list.itemsCount = list.listItemsByListId.totalCount;

        let boards: any[] = [];
        let materials = list.materialsByListId.nodes;

        if (materials.length > 0) {
          materials.forEach((material: any) => {
            if (material.boardByBoardId) {
              material.boardByBoardId.materialId = material.id;
              boards.push(material.boardByBoardId);
            }
          });
        }

        list.boards = boards;
        return list;
      });
    },
    SET_CURRENT_LIST(state: any, list: any) {
      state.list = list;
    },
    REMOVE_LIST(state: any, index: number) {
      state.lists.splice(index, 1);
    },
    SET_PDF_LINK(state: any, link: string) {
      state.pdfLink = link;
    },
  },
  actions: {
    async PULL_LIST(
      { commit }: any,
      { listId, listSlug }: { listId: number; listSlug: string },
    ) {
      const listInfo = `
          id
          name
          slug
          description
          type
          author
          publishDate
          listItemsByListId (
            orderBy: POSITION_ASC
          ) {
            totalCount
            nodes {
              questionByQuestionId {
                id
                content
                alternatives
                interactiveData
                answer
                reportsByQuestionId (
                  condition: {
                    done: false
                  }
                ) {
                  totalCount
                }
                repliesByAlternative {
                  nodes {
                    answer
                    total
                  }
                }
              }
              articleByArticleId {
                id
                title
                content
              }
              videoByVideoId {
                id
                providerId
                providerType
                description
                name
                duration
              }
            }
          }
          materialsByListId {
            nodes {
              id
              boardByBoardId {
                id
                title
                slug
                boardsClassroomsByBoardId {
                  nodes {
                    classroomByClassroomId {
                      id
                      name
                      slug
                    }
                  }
                }
              }
              boardSectionByBoardSectionsId {
                id
                title
              }
              boardSubsectionByBoardSubsectionsId {
                id
                title
              }
            }
          }
      `;
      let list;
      if (listId) {
        const response = await query(
          `query getLisByIdDexAdmin($listId: Int!) {
          listById(id: $listId) {
            ${listInfo}
          }
        }`,
          {
            listId,
          },
        );
        list = response.data.listById;
      } else if (listSlug) {
        const response = await query(
          `query getListBySlugDexAdmin($listSlug: String!) {
            listBySlug(slug: $listSlug) {
              ${listInfo}
            }
          }`,
          {
            listSlug,
          },
        );
        list = response.data.listBySlug;
      }
      commit('SET_CURRENT_LIST', list);
    },

    async PULL_LISTS(
      { commit, state, rootState }: any,
      { currentPage, searchListName }: any,
    ) {
      currentPage = currentPage || 0;
      searchListName = searchListName || '';
      let condition = '';
      if (searchListName.length > 0) {
        condition = `name: {
          includesInsensitive: "${searchListName}"
        }`;
      }
      let resultsPerPage = 50;
      let offset = resultsPerPage * currentPage;
      let response = await query(
        `query getAllLists2DexAdmin($resultsPerPage: Int, $offset: Int) {
        allLists(
          first: $resultsPerPage,
          offset: $offset,
          orderBy: ID_DESC,
          filter: {
            draft: {
              distinctFrom: true
            }
            ${condition}
          }
        ) {
          nodes {
            id
            name
            slug
            listItemsByListId {
              totalCount
            }
            materialsByListId{
              nodes {
                id
                boardByBoardId {
                  id
                  title
                }
              }
            }
          }
        }
      }`,
        {
          resultsPerPage,
          offset,
        },
      );
      let listsNodes = response.data.allLists;
      if (listsNodes) {
        commit('SET_LISTS', listsNodes.nodes);
      }
    },

    async GENERATE_PDF({ commit }: any, listId: number) {
      let response = await query(
        `query generatePFDDexAdmin($listId: Int!) {
        generatePdf(listId: $listId)
      }`,
        {
          listId: listId,
        },
      );
      commit('SET_PDF_LINK', response.data.generatePdf);
    },
  },
};
